import * as React from 'react';
import { withStyles, createStyles, Theme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

const jss = (theme: Theme) => createStyles({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        padding: '0px 32px',
    },
    question: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        margin: '10px 0px',
        padding: '20px',
        backgroundColor: theme.palette.secondary.main,
    },
    addOpt: {
        marginBottom: theme.spacing.unit,
    },
    removeBtn: {
        color: theme.palette.error.light,
        borderColor: theme.palette.error.light,
        '&:disabled': {
            borderColor: theme.palette.action.disabled,
        },
    },
    addRemove: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        marginBottom: theme.spacing.unit,
    }
});

interface Props {
    disabled?: boolean;
    number: number;
    question: Bee.Question;
    answer: Bee.Answer;
    addOption: (e: any) => void;
    removeOption: (e: any) => void;
    onLinkChange: (event: any) => void;
    onAnswerChange: (event: any) => void;
    onExplanationChange: (event: any) => void;
    onOptionChange: (ix: number, event: any) => void;
    classes: {
        container: string;
        question: string;
        addOpt: string;
        removeBtn: string;
        addRemove: string;
    }
}

class Question extends React.Component<Props> {
  	render() {
        const { classes } = this.props;
        
        return (
            <div className={classes.container}>
                <Typography variant="h4" align="center">{`Question ${this.props.number}`}</Typography>
                <TextField
                    label="Link"
                    variant="outlined"
                    margin="dense"
                    placeholder="Link to Quiz Video"
                    fullWidth
                    required
                    disabled={this.props.disabled}
                    value={this.props.question.url}
                    onChange={this.props.onLinkChange}
                />
                <Typography variant="h6" align="center">Options</Typography>
                {this.props.question.options.map((o, ix) => (
                    <TextField
                        key={ix}
                        // @ts-ignore
                        value={o}
                        label={`Option ${ix + 1}`}
                        variant="outlined"
                        placeholder="Option for answering the question"
                        margin="dense"
                        fullWidth
                        required
                        disabled={this.props.disabled}
                        onChange={(e: any) => this.props.onOptionChange(ix, e)}
                    />
                ))}
                <div className={classes.addRemove}>
                    <Button
                        variant="text"
                        color="primary"
                        size="small"
                        disabled={this.props.disabled}
                        onClick={this.props.addOption}
                    >
                        Add Option
                    </Button>
                    <Button
                        variant="text"
                        color="primary"
                        size="small"
                        onClick={this.props.removeOption}
                        className={classes.removeBtn}
                        disabled={this.props.question.options.length <= 2 || this.props.disabled}
                    >
                        Remove Option
                    </Button>
                </div>
                <TextField
                    select
                    label="Answer"
                    variant="outlined"
                    margin="dense"
                    value={this.props.answer.correctOption}
                    onChange={this.props.onAnswerChange}
                    helperText="Please select the correct answer for this question"
                    fullWidth
                    required
                    disabled={this.props.disabled}
                >
                    {this.props.question.options.map((option, ix) => (
                        <MenuItem key={ix} value={option}>
                            {option}
                        </MenuItem>
                    ))}
                </TextField>
                <Typography variant="h6" align="center">Answer Explanation</Typography>
                <TextField
                    label="Explanation"
                    variant="outlined"
                    margin="dense"
                    placeholder=""
                    fullWidth
                    required
                    multiline
                    disabled={this.props.disabled}
                    value={this.props.answer.description}
                    onChange={this.props.onExplanationChange}
                />
            </div>
        )
	}
}

export default withStyles(jss)(Question);



// WEBPACK FOOTER //
// ./src/components/Admin/Question.tsx